import React from "react";
import {AnimatePresence, motion} from "framer-motion";
import {BodyTitleText} from "@/app/components/texts";
import classNames from "classnames";
import styles from "./styles.module.scss";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Space, {spaceSizes} from "@/app/components/Space";
import {ReactPhotoCollage} from "react-photo-collage";

interface MessageBlockProps {
  userRequest: string;
  modelResponse: string;
  fileLinks: string[];
  isFirst: boolean;
  index: number;
}

const MessageBlock: React.FC<MessageBlockProps> = ({userRequest, modelResponse, fileLinks, isFirst, index}) => {
  const renderUserRequest = () => {
    if (fileLinks && fileLinks.length > 0) {
      // Настройки для ReactPhotoCollage
      const layout =
        fileLinks.length === 1
          ? [1]
          : fileLinks.length === 2
            ? [2]
            : fileLinks.length <= 4
              ? [2, 2]
              : [1, 4, 2];

      const collageSettings = {
        width: "100%",
        height: ["250px", "250px", "250px"],
        layout,
        photos: fileLinks.map((link) => ({ source: link })),
        showNumOfRemainingPhotos: true,
      };

      return (
        <div className={styles.galleryWrapper}>
          <ReactPhotoCollage {...collageSettings} />
        </div>
      );
    } else {
      // Если нет файлов, просто выводим текст
      return <BodyTitleText text={userRequest} />;
    }
  };

  return (
    <div className={styles.messageBloc}>
      {/* Блок пользователя (userRequest) */}
      <div
        className={classNames(
          styles.message,
          styles.userRequest,
          {
            [styles.hasFile]: fileLinks && fileLinks.length > 0,
            [styles.oneRow]:
            fileLinks.length === 1 || fileLinks.length === 2,
            [styles.twoRow]:
            fileLinks.length > 2 && fileLinks.length <= 4,
            [styles.threeRow]: fileLinks.length > 4
          }
        )}
      >
        {renderUserRequest()}
      </div>

      <div className={classNames(styles.message, styles.modelResponse)}>
        {modelResponse !== "" ? (
          isFirst ? (
            <AnimatePresence mode="wait">
              <motion.div
                key={`model-${index}`}
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                transition={{ duration: 0.3 }}
                style={{ overflow: "hidden" }}
              >
                <div className={styles.messageText}>
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {modelResponse}
                  </ReactMarkdown>
                </div>
              </motion.div>
            </AnimatePresence>
          ) : (
            <div className={styles.messageText}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {modelResponse}
              </ReactMarkdown>
            </div>
          )
        ) : (
          <Space h={spaceSizes.s28} />
        )}
      </div>
    </div>
  );
};

export default MessageBlock;
